import { FC } from 'react';
import { useAccountTagData } from '@hub/features/account-dashboard/hooks';
import { Stack, Typography } from '@mui/material';
import { SystemIcon } from '@monorepo/nova-icons';
import { Tag, Tooltip } from '@monorepo/nova-ui';
import { HeaderDetails } from '../../dashboard-header-info/header-details';
import { MetricList } from '../../dashboard-header-info/metric-list';
import { StatusDot } from '../../dashboard-header-info/status-dot';
import { useAccountNavigation } from '../hooks';
import { ProgramItemContainer } from '../styled';
import { ProgramItemProps } from '../types';

export const ProgramItem: FC<ProgramItemProps> = ({
  account,
  program,
  onClose,
  isCurrent = false,
}) => {
  const tagData = useAccountTagData(account);

  const { navigateToAccountDashboard } = useAccountNavigation(onClose);

  return (
    <ProgramItemContainer
      elevation={0}
      onClick={() => navigateToAccountDashboard(account)}
      isCurrent={isCurrent}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack direction="row" alignItems="center" gap={2}>
          <StatusDot status={tagData.status.statusDot} size={2} />
          <Typography
            variant="subtitle2"
            sx={(theme) => ({
              fontSize: theme.typography.pxToRem(18),
              fontWeight: theme.typography.fontWeightMedium,
            })}
          >
            {program.name}
          </Typography>
          {tagData.status.statusDot === 'inactive' &&
            tagData.status.tooltip && (
              <Tooltip title={tagData.status.tooltip} arrow>
                <span>
                  <SystemIcon iconName={'Warning'} size={15} color="error" />
                </span>
              </Tooltip>
            )}
        </Stack>

        <Stack direction="row" alignItems="center" gap={1}>
          <Tag
            label={tagData.tradingInstrument.label}
            color={tagData.tradingInstrument.color}
            size="small"
            sx={(theme) => ({
              padding: theme.spacing(0.5),
              fontSize: theme.typography.pxToRem(12),
            })}
          />
          <Tag
            label={tagData.accountType.label}
            color={tagData.accountType.color}
            size="small"
            sx={(theme) => ({
              padding: theme.spacing(0.5),
              fontSize: theme.typography.pxToRem(12),
            })}
          />
        </Stack>
      </Stack>

      <HeaderDetails compact={true} account={account} />

      <MetricList program={program} />
    </ProgramItemContainer>
  );
};
